/* eslint-disable @typescript-eslint/no-explicit-any */
import { cva } from 'class-variance-authority'
import { cn } from '~/lib/utils'

const accentColours = cva(
  'space-y-s sm:space-y-m border-l-[10px] sm:border-l-[12px] lg:border-l-[16px] pl-[24px] sm:pl-[32px]  ',
  {
    variants: {
      colour: {
        'ink-blue': 'border-blue-d',
        'mid-blue': 'border-blue-m',
        chartreuse: 'border-char',
        'light-pink': 'border-pink',
        'light-aqua': 'border-green',
        'light-orange': 'border-orange',
        'light-purple': 'border-purple',
        'light-blue': 'border-blue-l',
        white: 'border-white'
      }
    },
    defaultVariants: {
      colour: 'white'
    }
  }
)

const BlockQuote = ({ content, layoutColour }: any) => {
  const colour =
    layoutColour === 'ink-blue' ||
    layoutColour === 'mid-blue' ||
    layoutColour === 'white' ||
    layoutColour === 'light-grey'
      ? content.accentColour
      : layoutColour === 'chartreuse'
        ? 'mid-blue'
        : 'ink-blue'

  const foregroundColour =
    layoutColour === 'ink-blue' || layoutColour === 'mid-blue'
      ? 'text-white'
      : content?.strongColour &&
          (layoutColour === 'white' ||
            layoutColour === 'light-grey' ||
            layoutColour === 'chartreuse')
        ? 'text-blue-m'
        : 'text-blue-d'

  return (
    <div className='mx-auto flex max-w-[80ch] justify-center'>
      <blockquote className={cn(accentColours({ colour }))}>
        <div
          className={cn(
            'text-h2-sm sm:text-h2-md lg:text-h2-lg font-serif italic',
            foregroundColour
          )}
        >
          {content.quote}
        </div>
        {content.attribution && (
          <div>
            <p className='font-bold'>{content.attribution}</p>
            {content.role && <p>{content.role}</p>}
          </div>
        )}
      </blockquote>
    </div>
  )
}

export default BlockQuote
